// TODO: replace this file with the real ../config/roles.js from pms-frontend
// so the shell and the apps agree on role names.
export const ROLES = {
  SUPERADMIN: "superadmin",
  POWERADMIN: "poweradmin",
  VENDOR: "vendor",
  OWNER: "owner",
  OWNERGROUP: "ownergroup",
  FLEET_MANAGER: "fleet_manager",
  VESSEL_MANAGER: "vessel_manager",
  USER: "user",
  BRIDGE: "bridge",
  ENGINE_ROOM: "engine_room",
};

// Idempotent: mapping an already-mapped role returns the same value.
export const mapBackendRole = (role) =>
  typeof role === "string" ? role.trim().toLowerCase() : null;
